import { StepperProps } from 'components/stepper/Stepper';
import { useEffect, useState } from 'react';

const useStepper = (stepList: StepperProps['steps']) => {
  const [stepsData, setStepsData] = useState<typeof stepList>(stepList);
  const [previousStep, setPreviousStep] = useState<boolean>(false);
  const [nextStep, setNextStep] = useState<boolean>(false);

  const setActiveStep = (index: number) => {
    if (index > stepsData.length - 1) {
      throw new Error('Index can not be greater then steps');
    }
    setStepsData(
      stepsData.map((step, currentIndex) => {
        step.isActiveStep = index === currentIndex;
        return step;
      })
    );
  };
  const getActiveStepIndex = () => {
    const currentActiveStep = stepsData.find((elem) => elem.isActiveStep);

    return stepsData.indexOf(currentActiveStep!);
  };
  useEffect(() => {
    const currentActiveStepIndex = getActiveStepIndex();
    if (nextStep && currentActiveStepIndex !== stepsData.length - 1) {
      stepsData[currentActiveStepIndex + 1].isActiveStep = true;
      stepsData[currentActiveStepIndex].isActiveStep = false;
      setNextStep(false);
    }
  }, [nextStep]);

  useEffect(() => {
    const currentActiveStepIndex = getActiveStepIndex();
    if (previousStep && currentActiveStepIndex === 0) {
      throw new Error('Unable to go further back');
    }
    if (previousStep) {
      stepsData[currentActiveStepIndex - 1].isActiveStep = true;
      stepsData[currentActiveStepIndex].isActiveStep = false;
      setPreviousStep(false);
    }
  }, [previousStep]);
  return {
    setNextStep,
    setPreviousStep,
    stepsData,
    setActiveStep,
    getActiveStepIndex,
  };
};
export default useStepper;
